import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import H1 from '../H1';

import { mediaTablet, mediaPhone } from '../styles/breakpoints';

const Title = styled(H1)`
  padding-top: 50px;
  padding-bottom: 10px;

  ${mediaTablet} {
    padding-top: 74px;
  }

  ${mediaPhone} {
    padding-top: 36px;
  }
`;

const P = styled.p`
  font-family: 'PT Mono', monospace;
  font-weight: normal;
  font-size: 18px;

  ${mediaTablet} {
    font-size: 15px;
  }
`;

const Introduction = ({ className }) => (
  <article className={className}>
    <Title>
      Familien und Flucht aus der DDR
    </Title>
    <P>
      Acht Lerneinheiten für die Grundschule mit ergänzenden Materialien
      <span
        className={css`
          &:before {
            content: '/';
            margin-left: 0.5em;
            margin-right: 0.5em;
          }

          @media only screen and (min-width: 1280px) {
            &:before { display: none; }
            display: block;
          }

          font-weight: bold;
        `}
      >
        3.–6. Klasse
      </span>
    </P>
  </article>
);

Introduction.propTypes = {
  className: PropTypes.string,
};

Introduction.defaultProps = {
  className: undefined,
};

export default Introduction;



// WEBPACK FOOTER //
// ./src/components/PageHeader/Introduction.js